import i from './import';

export default {
  import: i,
};
